import SectionHeading from "./SectionHeading";
import { guideSteps } from "@/mocks/home";

export default function GuideSteps() {
  return (
    <section id="guide" className="bg-background-50 py-14 md:py-20 px-4 md:px-10">
      <SectionHeading
        eyebrow="防迷路指南"
        title="四步走，换多少次地址都不会找不到"
        desc="很多朋友不是进不去，而是不知道地址变了。按下面四步做，下次更新你也能第一时间跟上。"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {guideSteps.map((item) => (
          <div
            key={item.step}
            className="relative rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
          >
            <span className="font-heading text-3xl md:text-4xl font-black text-background-300">
              {item.step}
            </span>
            <h3 className="mt-3 text-base font-medium text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            <span className="absolute right-5 top-5 w-8 h-8 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center">
              <i className="ri-route-line" />
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}